/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './lens-specification.reducer';

export const LensSpecificationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const lensSpecificationEntity = useAppSelector(state => state.lensSpecification.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="lensSpecificationDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.lensSpecification.detail.title">LensSpecification</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.lensSpecification.id">Id</Translate>
            </span>
          </dt>
          <dd>{lensSpecificationEntity.id}</dd>
          <dt>
            <span id="issuedDate">
              <Translate contentKey="tinyMedicRestApp.lensSpecification.issuedDate">Issued Date</Translate>
            </span>
          </dt>
          <dd>{lensSpecificationEntity.issuedDate}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.lensSpecification.active">Active</Translate>
            </span>
          </dt>
          <dd>{lensSpecificationEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.lensSpecification.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{lensSpecificationEntity.timestampEntry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.lensSpecification.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{lensSpecificationEntity.microSec}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.lensSpecification.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{lensSpecificationEntity.lastUpdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.lensSpecification.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{lensSpecificationEntity.cursor}</dd>
          <dt>
            <span id="visionProductType">
              <Translate contentKey="tinyMedicRestApp.lensSpecification.visionProductType">Vision Product Type</Translate>
            </span>
          </dt>
          <dd>{lensSpecificationEntity.visionProductType}</dd>
          <dt>
            <span id="eyeSide">
              <Translate contentKey="tinyMedicRestApp.lensSpecification.eyeSide">Eye Side</Translate>
            </span>
          </dt>
          <dd>{lensSpecificationEntity.eyeSide}</dd>
          <dt>
            <span id="sphere">
              <Translate contentKey="tinyMedicRestApp.lensSpecification.sphere">Sphere</Translate>
            </span>
          </dt>
          <dd>{lensSpecificationEntity.sphere}</dd>
          <dt>
            <span id="cylinder">
              <Translate contentKey="tinyMedicRestApp.lensSpecification.cylinder">Cylinder</Translate>
            </span>
          </dt>
          <dd>{lensSpecificationEntity.cylinder}</dd>
          <dt>
            <span id="axis">
              <Translate contentKey="tinyMedicRestApp.lensSpecification.axis">Axis</Translate>
            </span>
          </dt>
          <dd>{lensSpecificationEntity.axis}</dd>
          <dt>
            <span id="prismAmount">
              <Translate contentKey="tinyMedicRestApp.lensSpecification.prismAmount">Prism Amount</Translate>
            </span>
          </dt>
          <dd>{lensSpecificationEntity.prismAmount}</dd>
          <dt>
            <span id="prismBase">
              <Translate contentKey="tinyMedicRestApp.lensSpecification.prismBase">Prism Base</Translate>
            </span>
          </dt>
          <dd>{lensSpecificationEntity.prismBase}</dd>
          <dt>
            <span id="mlPower">
              <Translate contentKey="tinyMedicRestApp.lensSpecification.mlPower">Ml Power</Translate>
            </span>
          </dt>
          <dd>{lensSpecificationEntity.mlPower}</dd>
          <dt>
            <span id="clPower">
              <Translate contentKey="tinyMedicRestApp.lensSpecification.clPower">Cl Power</Translate>
            </span>
          </dt>
          <dd>{lensSpecificationEntity.clPower}</dd>
          <dt>
            <span id="clBackCurve">
              <Translate contentKey="tinyMedicRestApp.lensSpecification.clBackCurve">Cl Back Curve</Translate>
            </span>
          </dt>
          <dd>{lensSpecificationEntity.clBackCurve}</dd>
          <dt>
            <span id="clDiameter">
              <Translate contentKey="tinyMedicRestApp.lensSpecification.clDiameter">Cl Diameter</Translate>
            </span>
          </dt>
          <dd>{lensSpecificationEntity.clDiameter}</dd>
          <dt>
            <span id="wearingDuration">
              <Translate contentKey="tinyMedicRestApp.lensSpecification.wearingDuration">Wearing Duration</Translate>
            </span>
          </dt>
          <dd>{lensSpecificationEntity.wearingDuration}</dd>
          <dt>
            <span id="color">
              <Translate contentKey="tinyMedicRestApp.lensSpecification.color">Color</Translate>
            </span>
          </dt>
          <dd>{lensSpecificationEntity.color}</dd>
          <dt>
            <span id="brand">
              <Translate contentKey="tinyMedicRestApp.lensSpecification.brand">Brand</Translate>
            </span>
          </dt>
          <dd>{lensSpecificationEntity.brand}</dd>
          <dt>
            <span id="notes">
              <Translate contentKey="tinyMedicRestApp.lensSpecification.notes">Notes</Translate>
            </span>
          </dt>
          <dd>{lensSpecificationEntity.notes}</dd>
          <dt>
            <span id="eyeReadingType">
              <Translate contentKey="tinyMedicRestApp.lensSpecification.eyeReadingType">Eye Reading Type</Translate>
            </span>
          </dt>
          <dd>{lensSpecificationEntity.eyeReadingType}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.lensSpecification.prescription">Prescription</Translate>
          </dt>
          <dd>{lensSpecificationEntity.prescription ? lensSpecificationEntity.prescription.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.lensSpecification.eye">Eye</Translate>
          </dt>
          <dd>{lensSpecificationEntity.eye ? lensSpecificationEntity.eye.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/lens-specification" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/lens-specification/${lensSpecificationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default LensSpecificationDetail;
